import ProductList from './ProductList.kr'
import ProductInfo from './ProductInfo.kr'
import ProductEdit from './ProductEdit.kr'
import UsedAmountProductList from "@/lang/product/UsedAmountProductList.kr";
export default {
  ...ProductList,
  ...ProductInfo,
  ...ProductEdit,
  ...UsedAmountProductList
}



// WEBPACK FOOTER //
// ./src/lang/product/kr.js